require('jqmask');

$.validator.addMethod(
  'zipValidation',
  (value, element) => {
    if ($(element).hasClass('required') === false) {
      return true;
    }

    if ((value === undefined) || (value === null) || (value === '')) {
      return false;
    }

    return (/^[0-8][0-9]*$/).test(value);
  }
);

$(() => {
  $("[data-id='zip']").mask('9999-999', { placeholder: '' });
});

$(document).on('initialized.ocms.ultimate-form', (event, form) => {
  if ((form !== undefined) && (form !== null) && (form.id === 'shipping')) {
    if ((OCMS.GlobalVars.Brand === 'occ')) {
      form.zipField.addClass('zipValidation');
    }
  }
});



// WEBPACK FOOTER //
// ./js/countryForm/portugal.form.js